module.exports = __webpack_public_path__ + "img/pending.8f12fef7.svg";